import { parseUrl } from '@onramp/utils/url';

export const getIsRoute = (route: string, href = window.location.href): boolean => {
  const url = parseUrl(href, window.location.href);
  if (!url) return false;

  const { pathname } = url;
  return pathname.startsWith(route);
};
